import { cva } from '@/styled-system/css';

export const toastProviderContentRecipe = cva({
  base: {
    position: 'fixed',
    insetInline: 0,
    pointerEvents: 'none',
    zIndex: 'toast',
    isolation: 'isolate',
  },
  variants: {
    placement: {
      'top-start': { insetBlockStart: 0 },
      'top': { insetBlockStart: 0 },
      'top-end': { insetBlockStart: 0 },
      'bottom-start': { insetBlockEnd: 0 },
      'bottom': { insetBlockEnd: 0 },
      'bottom-end': { insetBlockEnd: 0 },
    },
  },
});
